// extracted by mini-css-extract-plugin
export var rateTableCarrierDropdown = "_40-1";
export var rateTableServiceLevelDropdown = "_40-3";
export var rateTableTypeDropdown = "_40-0";
export var rateTableValueModeDropdown = "_40-2";